const BlockchainNetworkSkeleton = () => {
  return (
    <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          key={index}
          className="animate-pulse rounded-2xl border bg-card p-4"
        >
          <div className="flex items-center gap-4">
            <div className="h-14 w-14 rounded-xl bg-muted" />

            <div className="space-y-2">
              <div className="h-4 w-36 rounded bg-muted" />
              <div className="h-3 w-20 rounded bg-muted" />
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i}>
                <div className="mb-2 h-3 w-20 rounded bg-muted" />
                <div className="h-4 w-16 rounded bg-muted" />
              </div>
            ))}
          </div>

          <div className="mt-6 flex gap-3">
            <div className="h-10 flex-1 rounded bg-muted" />
            <div className="h-10 flex-1 rounded bg-muted" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlockchainNetworkSkeleton;
